import { render, staticRenderFns } from "./StudentErrorMessage.vue?vue&type=template&id=2d49727a&scoped=true&"
import script from "./StudentErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./StudentErrorMessage.vue?vue&type=script&lang=ts&"
import style0 from "./StudentErrorMessage.vue?vue&type=style&index=0&id=2d49727a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49727a",
  null
  
)

export default component.exports